export default class Interceptor {
lazy_load_script(id_trigger){
    const element_to_intercept = document.getElementById(id_trigger);
    if (element_to_intercept){
       const options = {
          root: null,
          threshold: 0.20,
          rootMargin: "-1000px"
       };
       const ob = new IntersectionObserver(this.intercept_app, options);
       ob.observe(element_to_intercept);
    }
 }
 intercept_app(entries) {
    try{
    entries.forEach((entry) => {
       try {
    if ( entry.isIntersecting ){
       this.error = entries;
     }else{
         this.error = entries;
        }
    } catch (error) {
       console.info(error);
   }
    });
   } catch (error) {
      console.info(error);
  }
 }
}